export function formatTicketId(ticketId) {
  return `#${ticketId}`;
}